import { render, staticRenderFns } from "./RequestValidate.vue?vue&type=template&id=72bba510"
import script from "./RequestValidate.vue?vue&type=script&lang=js"
export * from "./RequestValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports